export const isQuoteRevision = (value) => (
  (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value)))
  && Number.isSafeInteger(Number(value)) && Number(value) >= 0
);

export const requireQuoteRevision = (value) => {
  if (isQuoteRevision(value)) return Number(value);
  const error = new Error('La révision du devis est absente ou invalide. Rechargez la version actuelle avant de réessayer.');
  error.status = value == null ? 428 : 400;
  error.body = { code: value == null ? 'QUOTE_REVISION_REQUIRED' : 'QUOTE_REVISION_INVALID', applied: false };
  throw error;
};

export const localChangesDuringWrite = (context = {}) => {
  const error = new Error('L’opération a été enregistrée. Vos saisies effectuées pendant l’attente ont été conservées. Rechargez la version actuelle avant de continuer.');
  error.body = { code: 'QUOTE_LOCAL_CHANGES_DURING_WRITE', applied: true, ...context };
  return error;
};

export const quoteConflictMessage = 'Ce devis a été modifié depuis votre dernière consultation. Vos modifications locales ont été conservées. Rechargez la version actuelle avant de réessayer.';
